import $ from 'jquery';

import '../styles/main.css';

const getDataFromResponse = function (res, tag) {
  return res.getElementsByTagName(tag)[0].childNodes[1].data;
};

const getUHF = function (lang = 'en-us') {
  $.ajax({
    type: 'GET',
    url: `${process.env.YAMMER_ASSET_PATH}/uhf/${lang}.xml`,
  }).done(function (res) {
    const css = getDataFromResponse(res, 'cssIncludes');
    const headerHtml = getDataFromResponse(res, 'headerHtml');
    const footerHtml = getDataFromResponse(res, 'footerHtml');
    const js = getDataFromResponse(res, 'javascriptIncludes');

    const cssNode = $(css);
    // hide initially so it doesn't flicker
    const header = $(headerHtml).css('display', 'none');
    const footer = $(footerHtml).css('display', 'none');

    cssNode.on('load', function () {
      header.css('display', 'block').addClass('qa-marketing-page--uhf-header');
      footer.css('display', 'block').addClass('qa-marketing-page--uhf-footer');
    });
    $('head').append(cssNode);
    $('body').append(js);
    $('.ve-marketing-page-header--uhf').append(header);
    $('.ve-marketing-page-footer--uhf').append(footer);
  });
};

const initializePublicHomepage = function () {
  const lang = $('html').attr('lang');

  if ($('.ve-marketing-page-header--uhf').length || $('.ve-marketing-page-footer--uhf').length) {
    getUHF(lang);
  }
};

initializePublicHomepage();
